module.exports = __webpack_public_path__ + "static/media/food.3bf10fbd.png";